// vuejs 3.x && villus 1.x && graphql-ws && @villus/batch (queries)
//
// import { useClient, handleSubscriptions, defaultPlugins } from 'villus'
// import { batch } from '@villus/batch';
// import { createClient, PingMessage, PongMessage } from 'graphql-ws'
// import fetch from 'src/assets/api/fetch'
// import { readAccessTokenFromStorage } from 'src/boot/auth'
// import { ClientPluginOperation, ObserverLike, StandardOperationResult } from 'villus/dist/villus.d'
// import { Query, Mutation, Subscription } from 'src/graphql/types'
//
// let activeSocket: WebSocket
// let timeout = 0
// const wsClient = createClient({
//   url: `${process.env.WS}`,
//   lazy: false,
//   keepAlive: 10000,
//   // retryAttempts: 0,
//   connectionParams: () => {
//     const accessToken = readAccessTokenFromStorage()
//     if (accessToken) {
//       return {
//         authorization: `Bearer ${accessToken}`
//       }
//     }
//     return {}
//   },
//   on: {
//     connecting () { console.log('websocket connecting...') },
//     connected (socket: WebSocket) {
//       activeSocket = socket
//       console.log('websocket connected')
//     },
//     closed () { console.log('websocket closed') },
//     error () { console.log('websocket error') },
//     ping (received: PingMessage) {
//       if (!received) // sent
//         timeout = window.setTimeout(() => {
//           if (activeSocket.readyState === WebSocket.OPEN)
//             activeSocket.close(4408, 'Request Timeout')
//         }, 5_000) // wait 5 seconds for the pong and then close the connection
//     },
//     pong (received: PongMessage) {
//       if (received) clearTimeout(timeout) // pong is received, clear connection close timeout
//     }
//   }
// })
//
// const subscriptionForwarder = (operation: ClientPluginOperation) => {
//   return {
//     subscribe (obs: ObserverLike<StandardOperationResult<any>>) {
//       return {
//         unsubscribe: wsClient.subscribe({ query: operation.query }, obs)
//       }
//     }
//   }
// }
//
// const client = useClient({
//   url: '/graphql',
//   cachePolicy: 'network-only',
//   use: [batch({ fetch }), handleSubscriptions(subscriptionForwarder), ...defaultPlugins()]
// })
//
// export default {
//   client,
//   query: (operation: ClientPluginOperation) => client.executeQuery<Query>(operation),
//   mutate: (operation: ClientPluginOperation) => client.executeMutation<Mutation>(operation),
//   subscribe: (operation: ClientPluginOperation) => client.executeSubscription<Subscription>(operation)
// }


// vuejs 2.x && villus 0.x && subscriptions-transport-ws

import { createClient } from 'villus'
import { SubscriptionClient } from 'subscriptions-transport-ws'
import { Operation, QueryVariables, ObservableLike, OperationResult } from 'villus/dist/types/src/types.d'
declare type SubscriptionForwarder<TData = any, TVars = QueryVariables> = (operation: Operation<TVars>) => ObservableLike<OperationResult<TData>>;
import fetch from 'src/assets/api/fetch'
import { readAccessTokenFromStorage } from 'src/boot/auth'
import { Query, Mutation, Subscription } from 'src/graphql/types'

const subscriptionClient = new SubscriptionClient(`${process.env.WS}`, {
  timeout: 30000,
  minTimeout: 1000,
  lazy: false,
  reconnect: true,
  // reconnectionAttempts: 5,
  inactivityTimeout: 0, // 0 - disbale
  connectionParams: () => {
    const accessToken = readAccessTokenFromStorage()
    if (accessToken) {
      return {
        authorization: `Bearer ${accessToken}`
      }
    }
    return {}
  }
})
subscriptionClient.onConnecting(() => { console.log('websocket connecting...') })
subscriptionClient.onConnected(() => { console.log('websocket connected')})
subscriptionClient.onReconnecting(() => { console.log('websocket reconnecting...') })
subscriptionClient.onReconnected(() => { console.log('websocket reconnected') })
subscriptionClient.onDisconnected(() => { console.log('websocket disconnected') })
subscriptionClient.onError(() => { console.log('websocket error') })
const subscriptionForwarder = (operation: Operation<Subscription>) => subscriptionClient.request(operation)

const client = createClient({
  url: '/graphql',
  subscriptionForwarder: subscriptionForwarder as SubscriptionForwarder,
  cachePolicy: 'network-only',
  fetch
})

export default {
  client,
  query: (operation: Operation) => client.executeQuery<Query>(operation),
  mutate: (operation: Operation) => client.executeMutation<Mutation>(operation),
  subscribe: (operation: Operation) => client.executeSubscription<Subscription>(operation)
}
